import PropTypes from "prop-types";
import React from "react";
import { injectIntl } from "react-intl";
import DataGrid, { DataGridItem } from "components/data-grid";
import { AssetDisplay } from "components/thumbnail";
import { TextDisplay } from "components/display-data";
import { DownloadButton } from "components/buttons";
import { useAuthDataContext } from "components/auth";
import { getImgPathAsset, getImgPathCustomerAsset } from "config/paths";
import styles from "./styles/data.css.js";
import withStyles from "components/with-styles";
import Chip from "components/chip";

const AssetData = ({ asset, intl, classes }) => {
  const { token } = useAuthDataContext();
  const assetDownloadUrl =
    asset && asset.customerId ? getImgPathCustomerAsset(asset, token) : getImgPathAsset(asset, token);

  return !asset ? null : (
    <DataGrid>
      {asset && asset.categories && asset.categories.length > 0 && (
        <DataGridItem big>
          <TextDisplay label={intl.formatMessage({ id: "asset.categories" })}>
            <div className={classes.keywordContainer}>
              {asset.categories.map(category => (
                <Chip className={classes.category} key={category.name} label={category.name} />
              ))}
            </div>
          </TextDisplay>
        </DataGridItem>
      )}
      <DataGridItem>
        <TextDisplay label={intl.formatMessage({ id: "asset.codename" })}>{asset.codename}</TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay label={intl.formatMessage({ id: "common.description" })}>{asset.description}</TextDisplay>
      </DataGridItem>
      <DataGridItem>
        <TextDisplay label={intl.formatMessage({ id: "asset.format" })}>{asset.format}</TextDisplay>
      </DataGridItem>
      <DataGridItem>
        {asset.format !== "mp4" && (
          <TextDisplay label={intl.formatMessage({ id: "asset.size_px" })}>
            {asset.sizePx.x}x{asset.sizePx.y}
          </TextDisplay>
        )}
      </DataGridItem>
      <DataGridItem>
        <DownloadButton url={assetDownloadUrl} />
      </DataGridItem>
      <DataGridItem big>
        <AssetDisplay asset={asset} width={200} />
      </DataGridItem>
    </DataGrid>
  );
};

AssetData.propTypes = {
  /**
   * Data to represent
   **/
  asset: PropTypes.object,
};

export default withStyles(styles)(injectIntl(AssetData));
